import axios from 'axios';
import { handleSuccess, handleError } from './axiosHandler';
import { authHeader, authHeaderJson } from '../_helpers/auth-header';

import {config} from '../config';
const base_url = config.apiUrl;

export const appUsersService = {
  getAll,
  getById,
  add,
  edit,
  checkUserName,
  checkEmail,
  delete: _delete
};

function getAll(dto) {
	const url = base_url + 'User/' + 'GetAll';
	axios.interceptors.response.use(handleSuccess, handleError);
	return axios.post(url, dto, { headers: authHeaderJson()});
}

function getById(id) {
  const url = base_url + 'User/getById/' + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function checkUserName(userName) {
  const url = base_url + 'AspNetUsers/checkUserName/' + userName;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function checkEmail(email) {
  const url = base_url + 'AspNetUsers/checkEmail/' + email;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function add(form) {
  const url = base_url + 'user';
  axios.interceptors.response.use(handleSuccess, handleError);
  let user = JSON.parse(localStorage.getItem('user'));

  let headers = { 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + user.token };
  return axios.post(url, form, { headers: headers});
}

function edit(data) {
  const url = base_url + 'user/';
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.put(url, data, { headers: authHeaderJson()});
}

function _delete(id) {
  const url = base_url + 'user/' + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.delete(url, { headers: authHeader()});
}
